import React, { useEffect, useMemo, useState } from 'react';

import CustomFieldsInputs from 'bundles/apex/custom_fields/form/inputs';
import { get } from 'helpers/api';

import type { CustomField } from 'bundles/apex/custom_fields/types';
import type { FormContact } from './types';
import type { RecordWithCustomFields, Value } from 'bundles/apex/custom_fields/form/types';

interface Props {
  contact: FormContact;
  onChange?: (changes: Record<string, Value>) => void;
}

export default function ContactFormCustomFields({ contact, onChange }: Props) {
  const [allCustomFields, setAllCustomFields] = useState<CustomField[]>([]);

  useEffect(() => {
    (async () => {
      const allCustomFields = await get('/backoffice/contacts/custom_fields_config');
      setAllCustomFields(allCustomFields);
    })();
  }, []);

  const customFields: CustomField[] | undefined = useMemo(() => {
    return allCustomFields?.filter(customField => customField.contactTypes.includes(contact.contactType));
  }, [allCustomFields, contact.contactType]);

  if (customFields?.length === 0) {
    return null;
  }

  return (
    <form className="form-horizontal">
      <h3>Custom Fields</h3>
      <CustomFieldsInputs
        customFields={customFields}
        record={contact as unknown as RecordWithCustomFields}
        onChange={onChange}
      />
    </form>
  );
}
